import { Checkbox, Chip, TextField, makeStyles } from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
import React from "react";
import CheckBoxIcon from "@material-ui/icons/CheckBox";
import CheckBoxOutlineBlankIcon from "@material-ui/icons/CheckBoxOutlineBlank";

const AutoComplete = (props) => {

    const {
        options,
        placeholder,
        onChange,
        classes,
        limitTags
    } = props;


    const icon = <CheckBoxOutlineBlankIcon fontSize="small" className={classes.iconDimentions} />;
    const checkedIcon = <CheckBoxIcon fontSize="small" className={`${classes.iconDimentions} ${classes.iconColor}`} />;

    return (
        <Autocomplete
            options={options}
            className={classes.autocomplete}
            limitTags={limitTags}
            onChange={(e, value) => {
                onChange(value);
            }}
            disableCloseOnSelect
            multiple
            renderOption={(option, { selected }) => (
                <React.Fragment>
                    <Checkbox
                        icon={icon}
                        checkedIcon={checkedIcon}
                        style={{ marginRight: 8 }}
                        checked={selected}
                    />
                    {option}
                </React.Fragment>
            )}
            renderTags={(value, getTagProps) =>
                value.map((option, index) => (
                    <Chip
                        variant="outlined"
                        label={option}
                        {...getTagProps({ index })}
                    />
                ))
            }
            renderInput={(params) =>
                <TextField
                    {...params}
                    label={options?.length == 0 ? "Loading..." : placeholder}
                    variant="outlined" />}
        />
    )
}

export default AutoComplete;